module.exports = __webpack_public_path__ + "media/images/icons/membership_card-abf02cdb38ef54719b899ac93f46719a.png";